import { TransmuxUtility, type FlacDownmixConfig, type TransmuxUtilityOps } from '@mimir/common/mpegts/transmuxUtility';
import { invariant } from '@mimir/common/util/invariant';
import { type TransmuxerOp, type SegmentData, type TransmuxInput, prepareTransmuxInputs } from './transmuxerOp';
import { AudioOnlyTransmuxer } from '@mimir/common/mpegts/audioOnlyTransmuxer';
import type { FragmentedMp4Buffers } from '@mimir/common/mp4/fragmentedMp4Types';

/**
 * This is a simple implementation that does not care about
 * concurrency.
 */
export class SimpleTransmuxer implements TransmuxerOp {

  private transmuxer: TransmuxUtilityOps;
  private lastDecodedSegment: number | null = null;

  constructor(audioOnly: boolean) {
    this.transmuxer = audioOnly ? new AudioOnlyTransmuxer() : new TransmuxUtility();
  };

  async transmux(
    flacDownmixConfig: FlacDownmixConfig,
    segmentToDecode: number,
    segments: SegmentData[],
  ): Promise<FragmentedMp4Buffers> {

    // Now that we are ready to use the transmuxer, let's figure what we need to feed it with
    const inputs: TransmuxInput[] = prepareTransmuxInputs(segmentToDecode, this.lastDecodedSegment, segments);

    let result: FragmentedMp4Buffers | undefined;
    for (const input of inputs) {
      result = this.transmuxer.transmuxSegment(new Uint8Array(input.buffer), { url: input.url, segmentTime: input.segmentIndex }, flacDownmixConfig, input.onlyUseLastAacPacket);
      this.lastDecodedSegment = input.segmentIndex;
    }
    invariant(result, 'There should be a result');
    return result;
  }


  isInitialized(): boolean {
    return this.lastDecodedSegment !== null;
  }

  cleanup() {
  }
}
